module.exports = __webpack_public_path__ + "static/media/natalie-portman-lose.b4e974cb.jpg";